// release-notes.component.ts
import { Component } from '@angular/core';

interface ReleaseNote {
  version: string;
  date: string;
  summary: string;
  expanded: boolean;
  features?: string[];
  improvements?: string[];
  bugfixes?: string[];
  breaking: string[];
}

@Component({
    selector: 'app-release-notes',
    templateUrl: './release-notes.component.html',
    styleUrls: ['./release-notes.component.css'],
    standalone: false
})
export class ReleaseNotesComponent {
  releases: ReleaseNote[] = [
    {
      version: 'v12.0.1',
      date: 'September 24, 2026',
      summary: 'Pandemic Preparedness',
      expanded: false,
      features: [
        'Portal View',
        'Pandemic preparedness',
        'VAd dataset',
        'Latest link api implementation'
      ],
      improvements: [
        'FAQ reorganised',
        'Collaborators text update',
      ],
      bugfixes: [],
      breaking: []
    },
    {
      version: 'v11.0.4',
      date: 'July 22, 2026',
      summary: 'Tech debt',
      expanded: false,
      features: [
        'Implementation of Playwright for E2E'
      ],
      improvements: [
        'Angular version update',
        'Code coverage till 83%',
        'Code cleaning and code optimizations'
      ],
      bugfixes: [],
      breaking: []
    },
    {
      version: 'v11.0.4',
      date: 'Jun 26, 2026',
      summary: 'reCAPTCHA hotfix for the url',
      expanded: false,
      features: [],
      improvements: [],
      bugfixes: ['reCAPTCHA hotfix for the url'],
      breaking: []
    },
    {
      version: 'v11.0.3',
      date: 'May 28, 2026',
      summary: 'NVIDIA release phase 2',
      expanded: false,
      features: [
        'NVIDIA release phase 2',
        'Added complexes (Heterodimers)'
      ],
      improvements: [],
      bugfixes: [],
      breaking: []
    },
    {
      version: 'v10.2.0',
      date: 'March 16, 2026',
      summary: 'NVIDIA release phase 1',
      expanded: false,
      features: [
        'NVIDIA release phase 1',
        'Added only homodimers'
      ],
      improvements: [],
      bugfixes: [],
      breaking: []
    },
    {
      version: 'v9.0.1',
      date: 'February 17, 2026',
      summary: 'Third party dataset release',
      expanded: false,
      features: [
        'Third party dataset release',
       
      ],
      improvements: [],
      bugfixes: [],
      breaking: []
    },
    {
      version: 'v8.2.1',
      date: 'November 11, 2025',
      summary: 'Custom annotations',
      expanded: false,
      features: [
        'Custom annotations track added using provista',
       
      ],
      improvements: [],
      bugfixes: [],
      breaking: []
    },
     {
      version: 'v8.0.0',
      date: 'August 5, 2025',
      summary: 'New redeisgn pages',
      expanded: false,
      features: [
        'New redeisgn pages for entry pages in tabular format',
       
      ],
      improvements: [],
      bugfixes: [],
      breaking: []
    },
    {
      version: 'v7.0.0',
      date: 'Jun 4, 2025',
      summary: 'Server side rendering implemented',
      expanded: false,
      features: [
        'Server side rendering',
       
      ],
      improvements: [
        'Performance Optimization'
      ],
      bugfixes: [],
      breaking: []
    },
    {
      version: 'v6.4.0',
      date: 'May 9, 2025',
      summary: 'Anglular updated',
      expanded: false,
      features: [
        'Angular version updated to 19.2',
        'Downlaod service added to sequence search',
        'cif to bcif'
      ],
      improvements: [],
      bugfixes: [],
      breaking: []
    },
    {
      version: 'v6.4.0',
      date: 'April 7, 2025',
      summary: 'Bulk Download service for sequecnce search results',
      expanded: false,
      features: [
        'Implemented Download service for sequecnce search results ',
      ], 
      improvements: [
        'Refactor PAE into heatmap',
      ],
      bugfixes: [
        'Domains track alignments with PAE',
      ],
      breaking: []
    },
     {
      version: 'v6.3.2',
      date: 'March 17, 2025',
      summary: 'Bulk Download service for sequecnce search results',
      expanded: false,
      features: [],
      improvements: [
        'BETA sign removed from the search',
      ],
      bugfixes: [
        'Foldseek Edge case scenarios handled when it resets the database',
      ],
      breaking: []
    },
    {
      version: 'v6.3.0',
      date: 'March 3, 2025',
      summary: 'Domains and bulk download service',
      expanded: false,
      features: [
        'Domians tracks added on entry page',
        'Buld Download service implemented on search results page',
        'Buld Download service implemented on foldseek table on entry page'
      ],
      improvements: [],
      bugfixes: [],
      breaking: []
    }
  ];

  toggleExpand(release: ReleaseNote): void {
    release.expanded = !release.expanded;
  }
}
